import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Box, Chip, CircularProgress, FormControl, IconButton, MenuItem, Pagination, Select } from "@mui/material";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { listEmailTemplateAction, publishEmailTemplate } from "../../Actions/EmailTemplateAction";
import { getPermissionData, getUserData } from "../../Actions/common";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import { replacePlaceholders } from "../../utils/CommonFunctions";
import { formatDateTime } from "../Common/DateFormat";
import { ITEMS_PER_PAGE_OPTIONS, NETCLUES_URL, SUPPORT_EMAIL } from "../../config";
import CustomSnackbar from "../Common/snackBar";
import renderStatusBadge from "../../utils/badges";
import qbotLogoPng from "../../Assets/logo-white.svg";
import netcluesLogoGif from "../../Assets/netclues-logo.gif";
import { CommonTooltip } from "../../utils/tooltip";
import showConfirmation from "../../utils/Conformation";

const CustomToolbar = ({ selectedRows, handleDeleteSelected, searchValue, handleSearchApi, handleFilterData, handleResetFilters, filterButtonDisabled, resetButtonDisabled,templateTypeFilter,statusFilter,handleChangeDropdown }) => {
  return (
    <div className="custom-header ">
      <div className="card border-rounded-0 fiter-card">
        <div className="card-body p-5 pb-0">
          <div className="row">
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6  mb-5">
              <div className="input-group w-100">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text"
                    id="basic-addon1"
                  >
                    {" "}
                    <SearchIcon />
                  </span>
                </div>
                <input
                  type="text"
                  data-kt-table-widget-4="search"
                  className="form-control"
                  placeholder="Search"
                  name="search"
                  value={searchValue}
                  onChange={handleSearchApi}
                />
              </div>
            </div>
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6  mb-5">
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  value={templateTypeFilter}
                  name="templateType"
                  onChange={(e) => handleChangeDropdown(e, "templateType")}
                >
                  <MenuItem value="all">All Template</MenuItem>
                  <MenuItem value="1">Master</MenuItem>
                  <MenuItem value="0">Tenant</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={statusFilter}
                  name="status"
                  onChange={(e) => handleChangeDropdown(e, "status")}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-auto ms-auto d-flex flex-wrap gap-3 mb-5">
              <CustomTooltip
                title="Filter"
                placement="top"
                arrow
              >
                <span>
                  <button
                    className="btn text-primary btn-light btn-icon"
                    onClick={handleFilterData}
                    disabled={filterButtonDisabled}
                  >
                    <TableFilte />
                  </button>
                </span>
              </CustomTooltip>
              <CustomTooltip
                title="Reset"
                placement="top"
                arrow
              >
                <span>
                  <button
                    className="btn text-primary btn-light btn-icon"
                    onClick={handleResetFilters}
                    disabled={resetButtonDisabled}
                  >
                    <TableReset />
                  </button>
                </span>
              </CustomTooltip>

              <CoustomTooltip
                title="Column"
                placement="top"
                arrow
              >
                <span className="btn text-primary btn-light btn-icon grid-toolbar">
                  <GridToolbarColumnsButton
                    slotProps={{
                      button: {
                        className: "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                        style: {
                          width: "47px",
                          height: "44px",
                          minWidth: "unset",
                          borderRadius: "8px",
                        },
                        startIcon: <TableColumns />,
                      },
                    }}
                  />
                </span>
              </CoustomTooltip>

              {selectedRows.length !== 0 && (
                <CoustomTooltip
                  title="Delete"
                  placement="top"
                  arrow
                >
                  <span>
                    <button
                      className="btn btn-outline-danger  btn-icon btn-outline "
                      onClick={handleDeleteSelected}
                      disabled={selectedRows.length === 0}
                    >
                      <DeleteOutlineOutlinedIcon />
                    </button>
                  </span>
                </CoustomTooltip>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const EmailTemplatesListing = ({ handleEdit, handleView }, ref) => {
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [shouldFetchData, setShouldFetchData] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [templateTypeFilter, setTemplateTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const htmlBodyDataRef = useRef("");
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[0]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`) ? getPermissionData(`${userData?.id}_permissionData`) : [];
  const hasPermission = permissionData[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "templates");

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const fetchEmailTemplates = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await listEmailTemplateAction({
        page: currentPage,
        perPage: pageSize,
        searchQuery: searchValue,
        templateType: templateTypeFilter !== "all" ? templateTypeFilter : undefined,
        status: statusFilter !== "all" ? statusFilter : undefined,
      });
      setData(response?.data || []);
      htmlBodyDataRef.current = response?.htmlBody || "";
      setTotalCount(response?.totalCount || 0);
    } catch (err) {
      setSnackbar({ open: true, message: err?.message || "Failed to fetch email templates", severity: "error" });
    } finally {
      setIsLoading(false);
    }
  },[currentPage,pageSize,searchValue,statusFilter,templateTypeFilter]);

  useEffect(() => {
    if (shouldFetchData) {
      fetchEmailTemplates();
      setShouldFetchData(0);
    }
  }, [shouldFetchData,fetchEmailTemplates]);

  useImperativeHandle(ref, () => ({
    refetchEmailTemplateListing: fetchEmailTemplates,
  }));

  const handleChangeDropdown = (e, filterType) => {
    const value = e.target.value;
    
    if (filterType === "templateType") {
      setTemplateTypeFilter(value);
    } else if (filterType === "status") {
      setStatusFilter(value);
    }
    
    setFilterButtonDisabled(false);
    setResetButtonDisabled(false);
  };

  const handleToggleStatus = async (id, isActive) => {
      await showConfirmation("toggleStatus", {
          entityName: "Template",
          entityId: id,
          currentStatus: isActive,
          action: async () => {
              // Your existing code inside action
              const { status, message } = await publishEmailTemplate({ id, isActive: !isActive });
              if (!status) {
                  throw new Error(message || "Failed to update template status.");
              }
              return { status, message };
          },
          onSuccess: (res, newStatus) => {
              setSnackbar({ 
                  open: true, 
                  message: res?.message || `Template ${newStatus ? "activated" : "deactivated"} successfully.`, 
                  severity: "success" 
              });
              fetchEmailTemplates();
          },
          onError: (err) => {
              setSnackbar({ 
                  open: true, 
                  message: err?.message || "Something went wrong while updating status.", 
                  severity: "error" 
              });
          },
      });
  };

  const handleSearchApi = (e) => {
    const inputValue = e.target.value.trim();
    setSearchValue(inputValue);
    
    if (inputValue.length === 0 && templateTypeFilter === "all" && statusFilter === "all") {
      setFilterButtonDisabled(true);
    } else {
      setFilterButtonDisabled(false);
    }
    setSearchValue(inputValue);
  };

  const handleHtmlView = (row) => {
    const finalHtmlTemplate = replacePlaceholders(htmlBodyDataRef.current, {
      LOGO: qbotLogoPng,
      NETCLUES_LOGO: netcluesLogoGif,
      SUPPORT_EMAIL: userData?.settingData?.ADMIN_EMAIL || SUPPORT_EMAIL,
      NETCLUES_URL: NETCLUES_URL,
      BODY_DATA: row.body,
      CURRENT_YEAR: new Date().getFullYear(),
    });

    if (finalHtmlTemplate?.trim() !== "") handleView && handleView(finalHtmlTemplate);
  };

  const handleResetFilters = () => {
    setSearchValue("");
    setTemplateTypeFilter("all");
    setStatusFilter("all");
    setCurrentPage(1);
    setShouldFetchData(1);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(true);
  };

  const columns = [
    { field: "title", headerName: "Title", flex: 1, sortable: true },
    { field: "subject", headerName: "Subject", flex: 1, sortable: true },
    {
      field: "category",
      headerName: "Category",
      width: 140,
      sortable: false,
      renderCell: (params) => <>{params.row.category}</>,
    },
    {
      field: "isActive",
      headerName: "Status",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        const statusMap = {
          true: { text: "Active", status: "success" },
          false: { text: "Inactive", status: "default" },
        };

        const statusCode = params.row?.isActive ?? "0";

        const { text, status } = statusMap[statusCode] || {
          text: "Unknown",
          status: "default",
        };

        return renderStatusBadge({ status, title: text });
      },
    },
    {
      field: "isTenantTemplate",
      headerName: "Template Type",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        const isMasterTemplate = params.row?.isTenantTemplate === false;

        return (
          <Chip
            label={isMasterTemplate ? "Master" : "Tenant"}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 600,
              borderRadius: "8px",
              textTransform: "capitalize",
              color: isMasterTemplate ? "primary.main" : "secondary.main",
              borderColor: isMasterTemplate ? "primary.main" : "secondary.main",
            }}
          />
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Updated Date",
      width: 200,
      sortable: true,
      renderCell: (params) => <>{params.row.updatedAt ? formatDateTime(params.row.updatedAt, true) : "N/A"}</>,
    },
    ...(hasPermission?.canEdit || hasPermission?.canView || hasPermission?.canEmail
      ? [
          {
            field: "actions",
            headerName: "Actions",
            width: 180,
            sortable: false,
            align: "center",
            headerAlign: "center", 
            renderCell: (params) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center", 
                  justifyContent: "center",
                  width: "100%",
                  height: "100%", 
                  gap: 1,
                }}
              >
                {hasPermission?.canEmail && (
                  <CommonTooltip title={params.row?.isActive ? "Deactivate Template" : "Activate Template"}>
                    <IconButton
                      className="btn-custom-i text-primary"
                      onClick={() => handleToggleStatus(params.row?.id, params.row?.isActive)}
                    >
                      <PowerSettingsNewOutlinedIcon
                        fontSize="small"
                        color={params.row?.isActive ? "error" : "success"}
                      />
                    </IconButton>
                  </CommonTooltip>
                )}

                {hasPermission?.canEdit && (
                  <CommonTooltip title="Edit">
                    <IconButton
                      className="btn-custom-i text-primary"
                      onClick={() => handleEdit && handleEdit(params.row?.id)}
                    >
                      <EditOutlinedIcon />
                    </IconButton>
                  </CommonTooltip>
                )}

                <CommonTooltip title="View HTML">
                  <IconButton
                  className="btn-custom-i text-primary"
                    onClick={() => handleHtmlView(params.row)}
                  >
                    <VisibilityOutlinedIcon />
                  </IconButton>
                </CommonTooltip>
              </Box>
            ),
          },
      ]
  : []),
  ];

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) {
      return;
    }
  };

  const handleFilterData = () => {
    setIsLoading(true);
    setCurrentPage(1);
    setShouldFetchData(1);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
  };

  const handlePaginationChange = (event, value) => {
    setData([]);
    setSelectedRows([]);
    setCurrentPage(value);
    setShouldFetchData(1);
  };

  const handleRowsPerPageChange = (event) => {
    setData([]);
    setSelectedRows([]);
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setPageSize(newValue);
    setCurrentPage(1);
    setIsLoading(true);
    setShouldFetchData(1);
  };

  return (
    <Box>
      <DataGrid
        className="border-0"
        localeText={{ toolbarColumns: "" }}
        rows={data}
        columns={columns}
        autoHeight
        hideFooterRowCount={true}
        hideFooterPagination={true}
        hideFooter={true}
        loading={isLoading}
        // checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={(newSelection) => setSelectedRows(newSelection)}
        slots={{
          toolbar: CustomToolbar,
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        slotProps={{
          toolbar: {
            selectedRows,
            handleDeleteSelected,
            searchValue,
            handleSearchApi,
            handleFilterData,
            handleResetFilters,
            templateTypeFilter,
            statusFilter,
            handleChangeDropdown,
            filterButtonDisabled,
            resetButtonDisabled,
          },
        }}
        components={{
          loadingOverlay: () => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
              }}
            >
              <CircularProgress
                color="primary"
                size={24}
                style={{
                  marginRight: 10,
                }}
              />
              Loading...
            </div>
          ),
          noRowsOverlay: () =>
            isLoading ? null : (
              <div
                style={{
                  display: !isLoading && data.length === 0 ? "block" : "none",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                No Records Found
              </div>
            ),
        }}
        sx={DataGrid_SX}
      />

      <div className="card-footer d-flex align-items-center justify-content-between mt-7">
        <div className="d-flex align-items-center">
          <label className="fw-semibold me-3">{"Row per page"} </label>
          <FormControl
            variant="standard"
            style={{
              minWidth: 50,
            }}
          >
            <Select
              labelId="rows-per-page-label"
              id="rows-per-page"
              value={selectedRowsPerPage}
              onChange={handleRowsPerPageChange}
              label="Row per page"
            >
              {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Pagination
          count={Math.ceil(totalCount / selectedRowsPerPage)}
          siblingCount={0}
          page={currentPage}
          onChange={(event, value) => (value !== currentPage ? handlePaginationChange(event, value) : null)}
          variant="outlined"
          shape="rounded"
          className="custom-pagination mt-0 ms-5"
        />
      </div>

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </Box>
  );
};

export default forwardRef(EmailTemplatesListing);

EmailTemplatesListing.propTypes = {
  handleEdit: PropTypes.func.isRequired,
  handleView: PropTypes.func,
};
